<template>
    <CodiceFeanorView tool-module="stegoEmbed" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
